module.exports = __webpack_public_path__ + "static/media/xd.77aa5702.png";